import { Text } from "@mantine/core";

import type { JSX } from "react";

export function TranscriptLoading(): JSX.Element | undefined {
    return (
        <>
            <Text c="dark.3" size="xs">
                Transcript not started...
            </Text>
            <Text c="dark.3" size="xs" pr="xxl" mt="md" fs="italic">
                Only certain call types will have a transcript
            </Text>
        </>
    );
}
